import * as DateUtils from "./date.utils";

const Utils = {
  DateUtils,
};

export default Utils;
